<template>
	<div class="broadcast-announcement">
		<div class="broadcast-announcement-left">
			<Tree @changeSwitch="changeSwitch" :switchVal="switchVal" @nodeClick="nodeClick"></Tree>
		</div>
		<div class="broadcast-announcement-right">
			<TabelSearch :searchConfig="searchConfig" :searchParams="searchParams" @resetCallBack="resetCallBack" @search="setSearchParams"></TabelSearch>
			<Table :width="'100%'" :tableLoading="tableLoading" :tabelButtons="tabelButtons" :templateData="tableTemplateData"
			 :tableConfig="tableConfig" :pagination="pagination">
			</Table>
		</div>
		<!-- 发布 -->
		<el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="'发布广播'" :visible.sync="dialogVisible"
		 width="50%" :before-close="handleClose">
			<div class="form-detail">
				<div class="select-left">
					<div class="select-tree" v-for="(item,index) in treeList">
							<MoreTree :areaId="item.areaId" @nodeClick="nodeClick1"></MoreTree>
							<!-- <el-tree :ref="'selectedTree'+index" :props="props" @node-click="item.nodeClick" :load="item.loadNode" lazy>
							</el-tree> -->
					</div>
				</div>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
					<el-form-item label="标题" prop="title">
						<el-input style="width: 300px;" v-model="ruleForm.title"></el-input>
					</el-form-item>
					<el-form-item label="区域" prop="areaIds">
						<template>
							<div class="input-district" style="width: 300px;">
								<span v-if="ruleForm.areaIds.length===0">请在左侧选择发布区域</span>
								<div v-else class="select-input">
									<el-tag :key='tag.id' v-for="(tag,index) in ruleForm.areaIds" closable @close="handleRemove(index)">
										{{tag.name}}
									</el-tag>
								</div>
								<!-- <el-tree ref="selectedTree" show-checkbox :props="props" @check-change="handleChange"  :load="loadNode" lazy> </el-tree> -->
							</div>
						</template>
					</el-form-item>
					<el-form-item label="音频" prop="fileUrl">
						<el-upload ref='uploadAudio' class="upload-demo" :action="publicAPI.uploadFile" :on-change="handleChangeAudio"
						 :on-remove="handleRemoveAudio" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess" :show-file-list="false">
							 <div v-if="urlList.length!=0" class="urlLIst">
								<span>{{urlList[0].name}}</span>
							 </div>
							<el-button v-else size="small" type="primary">点击上传</el-button>
							<div slot="tip" class="el-upload__tip">上传音频只能是 MP3/MPEG/WMA/WAV 格式，且不超过15M</div>
							
						</el-upload>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit('ruleForm')">发布</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="audioPlayVisible" :title="audioTitle" width="500px">
			<!-- <audio :src="audio.fileUrl"></audio> -->
			<audioInfo v-if="audioPlayVisible" :theUrl='aduioUrl'></audioInfo>
			<!-- <video controls autoplay name='media'>
				<source :src="audio.fileUrl" type="audio/mpeg">
			</video> -->
		</el-dialog>
	</div>
</template>

<script>
	import Tree from '../../../../components/Tree/nodeTree';
	import MoreTree from '../../../../components/Tree/moreNodeTree.vue';
	import TabelSearch from '../../../../components/tabel-search/tabel-search';
	import publicAPI from '../../../../api-path/public-api.js';
	import {
		mediaApi
	} from '../../../../api-path/media-api.js';
	import PublicFn from '../../../../assets/js/publicFn.js';
	import audioInfo from '../audio-info'
	export default {
		name: "broadcast-announcement",
		components: {
			Tree,
			TabelSearch,
			audioInfo,
			MoreTree
		},
		data() {
			return {
				publicAPI,
				squareUrl: '',
				switchVal: false,
				areaId: '',
				areaName: '',
				//表格start
				searchConfig: {
					dataName: 'searchParams',
					items: [{
						key: 'time',
						valueType: 'datetimerange',
					}, {
						key: 'search',
						valueType: 'text',
						placeholder: '输入发布人/标题搜索'
					}]
				},
				searchParams: {
					search: '',
					areaId: '',
					areaName: '',
					startTime: '',
					endTime: '',
					isDown: false,
					page: 1,
					size: 15,
				},
				tableLoading: false,
				tabelButtons: [{
					type: 'add',
					title: "发布",
					level: 'addBroadcast',
					fn: () => {
						this.urlList=[];
						this.ruleForm = {
							title: '',
							areaIds: [],
							areaIdsStr: "",
							fileUrl: '',
						};
						this.dialogVisible = true;
					}
				}],
				tableTemplateData: [],
				tableConfig: {
					checkbox: false,
					checkboxFn: (data) => {
						console.log(data)
					},
					rows: [{
						label: '区域',
						prop: 'areaName',
					}, {
						label: '标题',
						prop: 'title',
						maxlength: 35,
						type: "popover",
						width: '200px'
					}, {
						label: '发布单位',
						prop: 'areaName',
					}, {
						label: '发布人',
						prop: "userName"
					}, {
						label: '发布时间',
						prop: 'createGmt'
					}],
					rowButtons: {
						width: '300px',
						items: [{
							label: '播放',
							fn: (data) => {
								this.aduioUrl = data.fileUrl;
								this.audioTitle = data.title;
								this.audioPlayVisible = true;
							}
						}, {
							label: '删除',
							type: 'danger',
							fn: (data) => {
								this.$confirm('是否删除该广播?', '删除区域', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									type: 'warning',
								}).then(() => {
									this.$http.get(`${mediaApi.del}`, {
										params: {
											id: data.id
										}
									}).then(res => {
										if (res.status === 200) {
											this.$message({
												type: 'success',
												message: '操作成功!',
											});
											this.setSearchParams();
										}
									})
								}).catch(() => {
									this.$message({
										type: 'info',
										message: '已取消删除',
									});
								});
							}
						}],
					},
				},
				pagination: {
					show: true,
					total: 0,
					page: 1,
					size: 15,
					sizeChange: this.sizeChange,
					pageChange: this.pageChange,
				},
				//表格end
				//表单配置start
				dialogVisible: false,
				ruleForm: {
					title: '',
					areaIds: [],
					fileUrl: '',
				},
				rules: {
					title: [{
						required: true,
						trigger: 'blur',
						message: '请填写标题',
					}],
					areaIds: [{
						required: true,
						trigger: 'blur',
						message: '请选择区域',
					}],
					fileUrl: [{
						required: true,
						trigger: 'blur',
						message: '请上传音频',
					}],

				},
				urlList:[],//音频列表
				//区域选择树
				props: {
					label: 'name',
					key: 'id',
					children: 'areaTreeListResList',
				},
				//音频播放
				audioPlayVisible: false,
				aduioUrl: '',
				audioTitle: '',

				//授权区域id
				choosedAreaId: "",
				treeList: [], //授权树
			}
		},
		created() {
			let areaAuthList = JSON.parse(localStorage.getItem('ur')).currentAuthSourceTreeDTOList;
			let result = [];
			if (areaAuthList.length != 0) {
				areaAuthList.map(item => {
					if (item.code == 'addBroadcast') {
						result.push(item);
					}
				})
				// this.choosedAreaId=result.length!=0?result[0].areaId:'';

				this.treeList = result;
			} else {
				this.choosedAreaId = localStorage.getItem('centerId') ? localStorage.getItem('centerId') : '0';
			}
		},
		methods: {
			changeSwitch(e) {
				this.switchVal = e;
				this.searchParams.isDown = e;
				this.isDown = e;
				this.setSearchParams();
			},
			nodeClick(node) {
				this.searchParams.areaId = node.id;
				this.areaId = node.id;
				this.areaName = node.id?node.name:"";
				this.searchParams.areaName = node.name;
				this.searchParams.page = this.pagination.page = 1;
				this.searchParams.size = this.pagination.size = 15;
				this.setSearchParams();
			},
			resetCallBack() {
				this.searchParams.page = this.pagination.page = 1;
				this.searchParams.size = this.pagination.size = 15;
				this.searchParams.startTime = '';
				this.searchParams.endTime = '';
				this.searchParams.search = '';
				this.searchParams.time = [];
				this.searchParams.areaId = this.areaId;
				this.searchParams.areaName = this.areaName;
				this.searchParams.isDown = this.isDown;
				this.setSearchParams();
			},
			// 每页显示条数
			sizeChange(size) {
				this.pagination.size = size;
				this.searchParams.size = size;
				this.setSearchParams()
			},
			// 当前页
			pageChange(page) {
				this.pagination.page = page
				this.searchParams.page = page;
				this.setSearchParams()
			},
			setSearchParams(value) {
				if (value) {
					this.pagination.page = value.page;
				}
				let params = JSON.parse(JSON.stringify(this.searchParams))
				if (params.time && params.time != '' && params.time.length != 0) {
					params.startTime = (PublicFn.formatDate(params.time[0])).toString();
					params.endTime = PublicFn.formatDate(params.time[1]).toString();
				}
				delete(params.time);
				this.$http.get(mediaApi.queryListByPage, {
					params: params
				}).then(res => {
					if (res.status === 200) {
						this.tableTemplateData = res.result.pageList;
						this.pagination.total = res.result.total;
					}
				})
			},
			handleClose() {
				this.$refs['ruleForm'].clearValidate();
				this.$refs.uploadAudio.clearFiles();
				this.dialogVisible = false;
			},
			//发布
			addHandleClose() {
				this.dialogVisible = false;
			},
			nodeClick1(node) {
				let result=this.ruleForm.areaIds.some(item=>{
					return item.id===node.id
				})
				if(!result){
					this.ruleForm.areaIds.push(node);
				}
			},
			handleRemove(index) {
				this.ruleForm.areaIds.splice(index, 1);
			},
			//上传音频
			handleAvatarSuccess(res) {
				// if(this.urlList.length!=0){
				// 	this.$confirm(`此操作将替换之前的音频, 是否继续?`, '提示', {
				// 	    confirmButtonText: '确定',
				// 	    cancelButtonText: '取消',
				// 	    type: 'warning'
				// 	}).then(() => {
				// 		if(res.msg == 'OK'){
				// 			this.ruleForm.fileUrl = res.result.url;
				// 			this.urlList=[res.result.url];
				// 		}
				// 	}).catch(() => { });
				// }else{
					if (res.msg == 'OK') {
						this.ruleForm.fileUrl = res.result.url;
						let oldList=JSON.parse(JSON.stringify(this.urlList));
						if(this.urlList.length!=0){
							this.$confirm(`此操作将替换之前的音频, 是否继续?`, '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								this.urlList=[res.result]
							}).catch(() => { 
								this.urlList=this.urlList.slice(0,1);
							});
						}else{
							this.urlList=[res.result];
						}
					}
				// }
			},
			handleRemoveAudio() {
				this.ruleForm.fileUrl = ''
			},
			handleChangeAudio(file,fileList) {
			},
			beforeAvatarUpload(file) {
				const isMP3 = file.type === 'audio/mp3';
				const isWMA = file.type === 'audio/wma';
				const isMPEG = file.type === 'audio/mpeg';
				const isWAV = file.type === 'audio/wav';

				const isLt15M = file.size / 1024 / 1024 < 15;
				if ((!isMP3) && (!isWMA) && (!isMPEG) && (!isWAV)) {
					this.$message.error('上传音频只能是 MP3/MPEG/WMA/WAV 格式!');
				}
				if (!isLt15M) {
					this.$message.error('上传音频大小不能超过 15MB!');
				}
				return (isMP3 || isWMA || isMPEG || isWAV) && isLt15M;
			},
			//添加
			onSubmit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let areaIds = [];
						this.ruleForm.areaIds.map(item => {
							areaIds.push(item.id)
						})
						let params = JSON.parse(JSON.stringify(this.ruleForm));
						params.areaIds = areaIds;
						this.$http.post(mediaApi.save, params).then(res => {
							if (res.status === 200) {
								this.$message.success('发布成功！');
								this.ruleForm = {
									title: '',
									areaIds: [],
									fileUrl: '',
								}
								this.$refs.uploadAudio.clearFiles();
								this.dialogVisible = false;
								this.resetCallBack();
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
		}
	}
</script>

<style lang="less" scoped>
	.broadcast-announcement {
		margin-left: 10px;
		box-sizing: border-box;
		height: 100%;
		padding:10px;
		border-radius: 10px;
		background: #fff;
		display: flex;

		.broadcast-announcement-left {
			margin-right: 10px;
			border-right: 1px solid #c1c1c1;
		}

		.broadcast-announcement-right {
			flex: 1;
			display: flex;
			flex-direction: column;
		}

		//发布
		.form-detail {
			display: flex;

			.input-district {
				width: 300px;
				border: 1px solid #DCDFE6;
				padding: 0 15px;
				max-height: 200px;
				overflow-y: auto;
				box-sizing: border-box;
				color: #999;

				.el-tag {
					margin: 5px;
				}
			}
			.select-left{
					max-height: 400px;
					width: 180px;
					overflow-y: auto;
				.select-tree {
					// max-height: 400px;
					// width: 180px;
					// overflow-y: auto;

					.el-tree {
						padding: 0 !important;
					}
				}
				
			}

			.avatar-uploader {}

		}
	}
</style>
